
<template>
  <!--产品分类-->
  <div>
    <!--面包屑-->
    <div class='table-bread'>
      <span class="title">当前位置：</span>
      <a-breadcrumb>
        <span slot="separator">></span>
        <template  v-for="(item, index) of levelList">
          <a-breadcrumb-item @click.native="clickBread(item, index)" :key="index">
            <span v-if="index === levelList.length - 1">{{item.name}}</span>
            <span :style="{ cursor: 'pointer' }" v-else type="link">{{item.name}}</span>
          </a-breadcrumb-item>
        </template>
      </a-breadcrumb>
    </div>

    <x-tabula
      ref="table"
      @resetSearch="resetSearch"
      :dataSource="dataSource"
      rowKey="categoryId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_t" slot-scope="{row}">
        <img  :style="{width: '30px', height: '30px'}" :src="row.imagesUrl" alt="">
      </template>
    </x-tabula>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'category',
  data () {
    return {
      levelList: [{ id: '', name: '首页' }],
      searchList: [
        { props: ['keywords'], placeholder: '分类名称', inputType: 'input' },
        { props: ['status'], placeholder: '状态', options: this.$store.state.statusList, inputType: 'select' },
        { props: ['createDate'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }
      ],
      searchParams: {
        keywords: '',
        status: '',
        createDate: '',
        parentId: ''
      },
      tableOptList: [{ text: '新增', icon: 'plus', permi: ['community:category:add'] }],
      rowOptList: [
        {text: '查看子类', handle: (row) => this.showSubCategory(row), permi: ['community:category:list']},
        {text: '添加子类', handle: (row) => this.toAddChild(row), permi: ['community:category:add'] },
        {text: '修改', handle: (row) => this.toEdit(row.categoryId), permi: ['community:category:edit']},
        [
          {text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), permi: ['community:category:remove']}
        ]
      ],
      columns: [
        { title: '类目名称', dataIndex: 'title', align: 'left', width: '' },
        { title: '标识', dataIndex: 'mark', align: 'left', width: '' },
        { title: '图标', dataIndex: 'imagesUrl', align: 'left', width: '', scopedSlots: {customRender: 't'} },
        { title: '创建时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '状态', dataIndex: 'statusDesc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/category/product',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addCategory',
        addTitle: '新增分类',
        editTitle: '修改分类'
      },
      deleteParam: {
        url: '/category/product',
        param: { pk_key: 'categoryId', pk_val: '' },
        title: this.setTitle(),
        key: 'title'
      }
    };
  },
  computed: {
    ...mapState(['categoryListApi', 'categoryRoute'])
  },
  created () {
    this.setApiUrl();
  },
  mounted () {
  },
  methods: {
    setTitle () {
      let categoryNameObj = { // 类目名称
        productCate: '产品分类',
        locationCate: '位置分类',
        apiCate: 'api分类',
        msgtplCate: '消息分类',
        docCate: '文档分类'
      };
      return categoryNameObj[this.$route.name];
    },
    /* 设置列表接口参数 */
    setApiUrl () {
      this.listApi.url = this.categoryListApi[this.$route.name];
      let index = this.categoryListApi[this.$route.name].indexOf('list');
      this.deleteParam.url = this.categoryListApi[this.$route.name].slice(0, index);
      this.addHandleParam.route = this.categoryRoute[this.$route.name];
    },
    resetSearch () {
      this.levelList.splice(1, this.levelList.length - 1);
    },
    /* 点击面包屑 */
    clickBread (item, index) {
      let len = this.levelList.length;
      if (index === len - 1) {
        return false;
      } else {
        this.levelList.splice(index + 1, len - (index + 1));
        this.resetData(this.searchParams);
        this.searchParams.parentId = item.id;
        this.$refs.table.getTableList();
      }
    },
    /* 查看下级 */
    showSubCategory (row) {
      let everySame = this.levelList.every(ele => ele.id !== row.categoryId);
      if (everySame) {
        this.levelList.push({
          id: row.categoryId,
          name: row.title
        });
        this.resetData(this.searchParams);
        this.searchParams.parentId = row.categoryId;
        this.$refs.table.getTableList();
      }
    },

    /* 进入添加子类 */
    toAddChild (row) {
      let idArr;
      // if (row.parentId !== '0') {
      //   idArr = [...row.parentId, row.categoryId];
      // } else {
      //   idArr = [row.categoryId];
      // }
      // idArr = [row.categoryId];
      // this.$router.push({
      //   name: this.categoryRoute[this.$route.name],
      //   query: { parentId: idArr, title: '添加子类' }
      // });
      if (row.parentIds.length) {
        idArr = [row.parentId, row.categoryId];
      } else {
        idArr = [row.categoryId];
      }
      this.$router.push({
        name: this.categoryRoute[this.$route.name],
        query: { parentId: idArr, title: '添加子类' }
      });
    },
    /* 进入编辑页面 */
    toEdit (id) {
      this.$router.push({
        name: this.categoryRoute[this.$route.name],
        query: { id: id, title: '修改分类', ...this.breadParam(this) }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
